<template>
    <v-row class="fill-height">
        <v-col>
            <v-card>
                <v-card-title>
                   <!-- <v-icon
                        @click="pushRouteToView('products')"
                        class="mr-4"
                        style="cursor: pointer"
                    >
                        mdi-arrow-left
                    </v-icon>-->
                    <v-btn small  @click="pushRouteToView('products')" class="mr-4 btn-back" >
                            <v-icon >
                        mdi-arrow-left
                             </v-icon>
                              Voltar
                            </v-btn>
                    <v-icon class="mr-1">mdi-shopping</v-icon>
                    Dados do Produto
                    <v-spacer></v-spacer>
                    <v-btn outlined class="btn-del"
                           @click="dialogDeleteProduct=true">
                        <v-icon left>mdi-delete</v-icon>
                        Excluir
                    </v-btn>
                    <v-btn outlined
                           :class="`${product.active? 'btn-inactive': 'btn-active'} mx-2`"
                           @click="dialogActiveInactive=true">
                        <span v-if="product.active"><v-icon left>mdi-diameter-variant</v-icon>Inativar</span><span v-else><v-icon
                        left>mdi-checkbox-marked-circle-outline</v-icon>Ativar</span>
                        <!--
                        <v-icon left>mdi-pencil</v-icon>
                        <span v-if="product.active">Inativar</span><span v-else>Ativar</span>
                        -->
                    </v-btn>
                    <v-btn
                        class="mr-4"
                        color="#3A33E8"
                        dark
                        :to="{ name: 'editProduct', params: { id: product.id } }"
                    >
                        <v-icon left>mdi-pencil</v-icon>
                        Editar
                    </v-btn>
                </v-card-title>
                <v-divider></v-divider>
                <v-card-text class="text-data-visualization">
                    <v-card style="border-left: solid 10px #3d1159 !important">
                        <v-card-title> </v-card-title>

                    <v-card-text class="text-data-visualization">
                                        
                    <v-row >                        
                        <v-col md="12" sm="12" xs="12">
                            <strong>Código:</strong>
                            {{ product.code }}
                        </v-col>
                        </v-row>
                        <v-row>
                         <v-col md="8" sm="8" xs="8">
                            <strong><v-icon>mdi-format-align-justify</v-icon> Descrição:</strong>
                            {{ product.description }}
                        </v-col>
                        <v-col md="4" sm="4" xs="4">
                            <strong><v-icon></v-icon>Classe:</strong>
                            {{ product.class }}
                        </v-col>
                        </v-row>
                        <v-row>
                            <v-col md="6" sm="12" xl="6">
                                <strong><v-icon>mdi-watermark</v-icon> Marca:</strong>
                            {{ product.brand }}
                            </v-col>
                            <v-col md="6"  sm="12" xl="6">
                                 <strong><v-icon>mdi-factory</v-icon> Fornecedor:</strong>
                            {{ product.supplier }}
                            </v-col>
                        </v-row>    
                        <v-row>
                            <v-col md="4" xl="4" sm="6">
                            <strong><v-icon></v-icon>Unidade de Estoque:</strong>
                            {{ product.unit }}
                           </v-col>
                           <v-col md="4" xl="4" sm="12" xs="12">
                            <strong><v-icon>mdi-bottle-tonic</v-icon>Tipo de Embalagem:</strong>
                            {{ product.package }}
                           </v-col>   
                           <v-col md="4" xl="4" sm="12" xs="12">
                            <strong><v-icon></v-icon>Categoria:</strong>
                            {{ product.category }}
                        </v-col>
                            
                        </v-row>
                        <v-row>
                             <v-col md="4" xl="4" sm="12" xs="12">
                            <strong><v-icon>mdi-barcode</v-icon> Código de Barras:</strong>
                            {{ product.barCode }}
                        </v-col>
                             <v-col md="4" xl="4" sm="6" xs="12">
                            <strong><v-icon>mdi-numeric</v-icon> Código do Fabricante</strong>
                            {{ product.manufacturerCode }}
                            </v-col>
                            <v-col md="4" xl="4" sm="6" xs="12">
                            <strong><v-icon>mdi-arrow-down-box</v-icon> Estoque Mínimo:</strong>
                            {{ product.minimumStock }}
                            </v-col>
                            
                        </v-row>
                        <v-row>
                            <v-col md="4" xl="4" sm="6" xs="12">
                            <strong><v-icon>mdi-arrow-up-box</v-icon> Estoque Máximo:</strong>
                            {{ product.maximumStock }}
                         </v-col>
                            <v-col md="4" xl="4" sm="12" xs="12">
                            <strong>Comissiona BM:</strong>
                            {{ product.commissionBM ? 'Sim' : 'Não' }}
                            </v-col>
                             <v-col md="4" sm="12" xs="12" xl="4">
                            <strong><v-icon>mdi-currency-usd</v-icon> Preço de Custo:</strong>
                            {{ product.costPrice | money }}
                            </v-col>
                            
                        </v-row>  
                        <v-row>
                        <v-col md="6" sm="12" xs="12" xl="6">
                            <strong><v-icon>mdi-currency-usd</v-icon> Preço de Venda:</strong>
                            {{ product.salesPrice | money }}
                            </v-col>
                             <v-col md="6" sm="12" xs="12" xl="6">
                            <strong><v-icon>mdi-percent</v-icon> Margem:</strong>
                            {{ product.profitMargin }}%
                            </v-col>  
                        </v-row>  
                        
                    </v-card-text>
                    </v-card>
                </v-card-text>
                <v-card-title>
                    Estoque
                </v-card-title>
                <v-card-text>
                    <v-card style="border-left: solid 10px #3d1159 !important">
            <v-card-title> </v-card-title>

            <v-card-text class="text-data-visualization">
                    <v-form
                        v-model="isValidProduct"
                        @submit.prevent="submitEstoque()"
                        ref="stockForm"
                    >
                      
                            <v-row>
                                <v-col md="4" sm="6">
                                    <v-text-field
                                        v-model="product.quantity"
                                        filled
                                        disabled
                                        type="number"
                                        :rules="textRules"
                                        label="Quantidade"
                                        append-icon="mdi-format-list-numbered"
                                    />
                                </v-col>
                                <v-col md="4" sm="6">
                                    <v-text-field
                                        v-model.number="quantity"
                                        outlined
                                        type="number"
                                        :rules="textRules"
                                        label="Quantidade"
                                        placeholder="Atualizar Estoque "
                                        append-icon="mdi-format-list-numbered"
                                    />
                                </v-col>
                                <v-col md="4" sm="6">
                                    <number-input
                                        label="Preço de custo"
                                        v-model.number="costPrice"
                                        placeholder="Preço de Custo do Produto"
                                        :rules="textRules"
                                        outlined
                                        :options="optionsMoney"
                                        append-icon="mdi-currency-usd"
                                    ></number-input>
                                </v-col>
                                </v-row>
                                <v-row>
                                <v-col md="4" sm="6">
                                    <number-input
                                        label="Preço de venda"
                                        v-model.number="salesPrice"
                                        placeholder="Preço de Venda do Produto"
                                        :rules="textRules"
                                        outlined
                                        :options="optionsMoney"
                                        @input="salesPriceUpdate"
                                        append-icon="mdi-currency-usd"
                                    ></number-input>
                                </v-col>
                                <v-col md="4" sm="6">
                                    <number-input
                                        label="Margem de Lucro"
                                        v-model.number="profitMargin"
                                        placeholder="Informe a percentagem"
                                        :rules="textRules"
                                        outlined
                                        disabled
                                        :options="optionsCommission"
                                         append-icon="mdi-currency-usd"
                                    ></number-input>
                                </v-col>

                                <v-col md="4" sm="6" justify="left">
                                    <v-btn
                                        class="mt-2"
                                        type="submit"
                                        color="success"
                                        dark
                                    >
                                        <v-icon left>
                                            mdi-content-save
                                        </v-icon>
                                        Salvar
                                    </v-btn>
                                </v-col>
                                </v-row>
                            
                       
                    </v-form>
            </v-card-text>
                    </v-card>
                </v-card-text>
                <confirm-dialog
                    :dialog="dialogActiveInactive"
                    :title="`${product.active? 'INATIVAR ': 'ATIVAR '} ${product.description}`"
                    body="Tem certeza que desenha realizar essa ação?"
                    @dialog-event="inactiveActive">
                </confirm-dialog>
                <confirm-dialog
                    :dialog="dialogDeleteProduct"
                    :title="`EXCLUIR  ${product.description}`"
                    :body="`Tem certeza que deseja excluir o produto ${product.description} ?`"
                    @dialog-event="deleteProduct">
                </confirm-dialog>
            </v-card>

        </v-col>
    </v-row>

</template>

<script>
import {mask} from "vue-the-mask";
import store from "@/store";
import NumberInput from '@/components/NumberInput'
import ConfirmDialog from '@/components/ConfirmDialog'

import {PRODUCT_RESET_STATE, SET_PRODUCT_ACTIVE} from "@/store/mutations/product.type";
import {PRODUCT_GET, PRODUCT_ACTIVE, PRODUCT_INACTIVE, PRODUCT_DELETE, PRODUCT_UPDATE_STOCK} from "@/store/actions/product.type";
import {mapGetters} from "vuex";
import {CHANGE_PROGRESS} from "@/store/mutations/mutations.type";



export default {
    name: 'ProductPage',
    directives: {mask},

    props: {
        id: {
            default: 0,
            type: Number,
            required: true
        }
    },
    components: {NumberInput,ConfirmDialog},
    async beforeRouteUpdate(to, from, next) {
        // Reset state if user goes from /editor/:id to /editor
        // The component is not recreated so we use to hook to reset the state.
        await store.commit(PRODUCT_RESET_STATE);
        return next();
    },
    async beforeRouteEnter(to, from, next) {
        Promise.all([
            await store.commit(PRODUCT_RESET_STATE),
            await store.dispatch(PRODUCT_GET, to.params.id),
        ]).then(() => {
            next();
        });
    },

    data: () => ({

        quantity: null,
        costPrice: null,
        salesPrice: null,
        profitMargin: null,

        isValidProduct: false,

        dialogActiveInactive:false,
        dialogDeleteProduct:false,

        optionsMoney: {
            locale: "pt-BR",
            prefix: "R$:",
            length: 7,
            precision: 2
        },
        optionsCommission: {
            locale: "pt-BR",
            prefix: "",
            length: 4,
            precision: 2
        },

        //rules
        textRules: [
            v => !!v || "Este campo é obrigatório"
            //v => v > 0 || "Esta campo deve ter um valor maior que zero."
        ],
    }),
    methods: {
        pushRouteToView(route) {
            this.$router.push({name: route})
        },
        salesPriceUpdate() {
            let m = (this.salesPrice - this.costPrice) / this.salesPrice
            this.profitMargin = (m.toFixed(4) * 100).toFixed(2)
        },
        submitEstoque() {

            if (this.$refs.stockForm.validate()) {

                this.inProgress = true;
                // this.bloqueiaEnvio = true;
                let payload = {
                    id: this.id,
                    costPrice: this.costPrice,
                    quantity: this.quantity,
                    salesPrice: this.salesPrice,
                    profitMargin: this.profitMargin
                };

                // console.log(payload);

                this.$store
                    .dispatch(PRODUCT_UPDATE_STOCK, payload)
                    .then(async () => {
                        this.inProgress = false;

                        this.snackbar.snackbar = true;
                        this.snackbar.color = "success";
                        this.snackbar.text = "Atualizado com sucesso";

                        await store.dispatch(PRODUCT_GET, this.id)
                        this.$refs.stockForm.resetValidation();
                        this.quantity = null
                        this.costPrice = null
                        this.salesPrice = null
                        this.profitMargin = null
                    })
                    .catch(({response}) => {
                        this.inProgress = false;
                        this.snackbar.snackbar = true;
                        this.snackbar.color = "error";
                        this.snackbar.text = "Erro ao atualizar estoque.";
                        // console.log(response.data);
                        if (typeof response.data.message !== "undefined") {
                            this.snackbar.text =
                                "Erro ao atualizar estoque: " +
                                response.data.message;
                        }
                    });
            } else {
                this.snackbar.snackbar = true;
                this.snackbar.color = "error";
                this.snackbar.text = "Preencha o formulário corretamente";
            }
        },
        deleteProduct(status){
            this.dialogDeleteProduct=false
            if(!status){
                return
            }
            this.$store.commit(CHANGE_PROGRESS, true)
            this.$store
                .dispatch(PRODUCT_DELETE)
                .then(() => {

                    this.$store.commit(CHANGE_PROGRESS, false)
                    this.snackbar.snackbar = true;
                    this.snackbar.color = "success";
                    this.snackbar.text = "Excluído com sucesso";

                    this.$router.push({
                        name: "products",
                    });
                })
                .catch(({response}) => {
                    this.$store.commit(CHANGE_PROGRESS, false)
                    this.snackbar.snackbar = true;
                    this.snackbar.color = "error";
                    this.snackbar.text = "Erro ao excluir.";
                    // console.log(response.data);
                    if (typeof response.data.message !== "undefined") {
                        this.snackbar.text = response.data.message;
                    }
                });
        },
        inactiveActive(status) {
            this.dialogActiveInactive=false
            if(!status){
                return
            }
            let action = this.product.active ? PRODUCT_INACTIVE : PRODUCT_ACTIVE;
            this.$store.commit(CHANGE_PROGRESS, true)

            this.$store
                .dispatch(action, this.product.id)
                .then(() => {

                    this.$store.commit(CHANGE_PROGRESS, false)
                    this.snackbar.snackbar = true;
                    this.snackbar.color = "success";
                    this.snackbar.text = "Alterado com sucesso";
                    this.$store.commit(SET_PRODUCT_ACTIVE, !this.product.active)
                })
                .catch(({response}) => {
                    this.$store.commit(CHANGE_PROGRESS, false)
                    this.snackbar.snackbar = true;
                    this.snackbar.color = "error";
                    this.snackbar.text = "Erro ao alterar.";
                    // console.log(response.data);
                    if (typeof response.data.message !== "undefined") {
                        this.snackbar.text = response.data.message;
                    }
                });
        }
    },
    computed: {
        // ...mapState({
        //   courses: state => state.
        // })

        ...mapGetters(["checkUsers", "product", "snackbar"])
    },
    watch: {}
}
</script>
